import { app } from "../db/firebaseConnection";
import { Destination } from "../models/destination";
import { doc, getFirestore, getDoc } from "firebase/firestore";
const db = getFirestore(app);

export const getSingleDestination = async (id) => {
  try {
    return new Promise((resolve, reject) => {
      console.log("Fetching Destination")
      const newCityRef = doc(db, "Destination", id);
      getDoc(newCityRef)
        .then((data) => {
          console.log("Destination point Fetched Successfully",data.data())
          if (data.exists()) {
            console.log("Destination point exists")
            resolve({
              error: false,
              Status: 200,
              message: "Record fetched successfully",
              data: data.data(),
            });
          } else {
            resolve({
              error: false,
              Status: 404,
              message: "No record found",
              data: "",
            });
          }
        })
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error?.code;
          var errorMessage = error?.message;
          resolve({
            error: false,
            Status: 401,
            message: "Document fetched failed",
            data: errorCode,
          });
        });
    });
  } catch (error) {
    return {
      error: true,
      Status: 501,
      message: "Internal Server Error",
      data: error.message,
    };
  }
};
